<template>
    <span>
        <b-button class="firmware-download" :disabled="downloading" @click="download">{{$t('firmware.info.download')}}</b-button>
        <span v-if="downloadError" class="text-danger firmware-download-error" role="alert">{{$t('firmware_download_error')}}</span>
    </span>
</template>
<script>
import axios from 'axios';
import { RequestGuard } from '../../utils/RequestGuard';
import { saveDownload, firmwareFilename } from '../../utils/FirmwareDownload';

export default {
    name: 'FirmwareDownload',
    props: { firmware: { type: Object, required: true } },
    data() { return { downloading: false, downloadError: false, guard: new RequestGuard() }; },
    methods: {
        async download() {
            const request = this.guard.begin();
            if (request === null) return;
            this.downloading = true; this.downloadError = false;
            try {
                const path = this.firmware.firmwareDownloadLink;
                // Downloads supplied by the API must stay on the current origin.
                if (typeof path !== 'string' || !path || new URL(path, window.location.href).origin !== window.location.origin) throw new Error('Invalid download URL');
                const response = await axios.get(path, { ...this.guard.config(request), responseType: 'arraybuffer' });
                if (!this.guard.isCurrent(request)) return;
                saveDownload(response.data, firmwareFilename(response.headers?.['content-disposition'], this.firmware));
            } catch (error) {
                if (this.guard.isCurrent(request) && error.response?.status !== 401) this.downloadError = true;
            } finally {
                if (this.guard.isCurrent(request)) { this.downloading = false; this.guard.finish(request); }
            }
        },
        invalidate() { this.guard.invalidate(); this.downloading = false; this.downloadError = false; },
    },
    watch: { firmware() { this.invalidate(); } },
    beforeDestroy() { this.guard.invalidate(); },
};
</script>
